export type ToastVariant = 'error' | 'success' | 'warning';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface Toast {
  id: string;
  message: string;
  variant: ToastVariant;
  duration: number;
  action?: ToastAction;
  dismissible: boolean;
}

export interface ShowToastOptions {
  message: string;
  variant: ToastVariant;
  duration?: number;
  action?: ToastAction;
  dismissible?: boolean;
}

export const MAX_TOASTS = 4;

export const DEFAULT_TOAST_DURATIONS: Record<ToastVariant, number> = {
  error: 0,
  success: 5000,
  warning: 5000,
};
